module.exports = __webpack_public_path__ + "static/step-2-2a-1-edit-button-75ba9aa370f3ec37adb1c833b090ed7c.png";